import { benefits } from '../../../mocks/services';

const BenefitsSection = () => {
  return (
    <section id="beneficios" className="py-20 bg-gradient-to-br from-gray-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            ¿Por qué confiar en <strong>nosotros</strong>?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Nos comprometemos con la excelencia en cada servicio que realizamos en tu hogar
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit) => (
            <div
              key={benefit.id}
              className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-teal-500/10 rounded-full mb-6">
                <i className={`${benefit.icon} text-3xl text-teal-500`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;